//@ts-nocheck
//@ts-nocheck
import { flow, getEnv, getSnapshot, types } from "mobx-state-tree";
import { AdapterType } from "../adapter";
const VideoStore = types
  .model("VideoUpload", {
    id: types.optional(types.string, ""),
    url: types.optional(types.string, ""),
    status: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get completed() {
        return ["completed", "finalist", "archived"].includes(self.status);
        // return self.url.includes("http");
      },
      get formValues() {
        return {
          id: self.id,
          url: self.url,
          status: self.status,
        };
      },
    };
  })
  .actions((self) => {
    return {
      updateFields(value: { id: string; url: string }) {
        self.id = value.id;
        self.url = value.url;
      },
    };
  });
export const OtherStore = types
  .model("OtherStore", {
    newDevelopment: types.optional(types.boolean, false),
    videoSummary: types.optional(VideoStore, {}),
    loading: types.optional(types.boolean, false),
    premium: types.optional(types.boolean, false),
    canApply: types.optional(types.boolean, false),
    inProbation: types.optional(types.boolean, false),
    isDeluxe: types.optional(types.boolean, false),
    approved: types.maybe(types.boolean),
    submission: types.maybe(types.boolean),
    videoVerified: types.optional(types.boolean, false),
  })
  .views((self) => {
    return {
      get formValues() {
        return {
          newDevelopment: self.newDevelopment,
          submission: self.submission,
          videoSummary: self.videoSummary,
        };
      },
      get youtubeValues() {
        return getSnapshot(self.videoSummary);
      },
      get completed() {
        return self.newDevelopment;
      },

      get level() {
        let level = self.inProbation
          ? "probation"
          : self.isDeluxe
          ? "deluxe"
          : self.premium
          ? "premium"
          : "standard";
        return level;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv<{ adapter: AdapterType }>(self);
    const submitVideoRecording = flow(function* submitVideoRecording(url) {
      try {
        self.loading = true;
        let response = yield adapter.submitVideoRecording(url);
        self.videoSummary.updateFields(response);
        self.loading = false;
        return response;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });

    return {
      setVideoUrl(video) {
        self.videoSummary.updateFields({ id: "youtube", url: video });
      },
      submitVideoRecording,
      updateFields(response: { id: string; url: string }) {
        self.videoSummary.updateFields(response);
      },
      onBeginApplication() {
        self.canApply = true;
      },
    };
  });
